import { render, staticRenderFns } from "./Screening.vue?vue&type=template&id=23a606ba&"
import script from "./Screening.vue?vue&type=script&lang=js&"
export * from "./Screening.vue?vue&type=script&lang=js&"
import style0 from "./Screening.vue?vue&type=style&index=0&id=23a606ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports